module.exports = __webpack_public_path__ + "static/Manticore-95fa5651398425ae9de77d95dee11d0f.jpg";